export const userCentrics = `
body.unfinished-usercentrics #uc-banner-modal {
    display: none;
}
`;
